import type { MeResponse } from './AuthProvider';
import { cfdiNoticeView } from './cfdiNotice';

/**
 * V222 (C-03/C-17) — banner persistente de facturación arriba de toda la app (incluido el
 * inicio). Solo llega al SUPER_USER (el backend manda `cfdiNotice` = null a los demás).
 * No bloquea nada: avisa que la factura global no se va a emitir o que el CSD venció/vence.
 * "Ir a Emisor CFDI" abre Configuración (el Dashboard escucha `fluidsol:navigate`).
 */
export function CfdiNoticeBanner({ me }: { me: MeResponse }) {
  const v = cfdiNoticeView(me.tenant.cfdiNotice);
  if (!v) return null;
  const cls = v.tone === 'rose'
    ? 'border-rose-300 bg-rose-100 text-rose-900'
    : 'border-amber-200 bg-amber-50 text-amber-900';
  return (
    <div role="status" className={`border-b ${cls}`}>
      <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-x-3 gap-y-1 px-4 py-2 text-xs font-medium md:px-6">
        <span className="min-w-0 flex-1">{v.text}</span>
        <button
          type="button"
          onClick={() => window.dispatchEvent(new CustomEvent('fluidsol:navigate', { detail: 'settings' }))}
          className="shrink-0 underline underline-offset-2 hover:no-underline">
          Ir a Emisor CFDI
        </button>
      </div>
    </div>
  );
}
